<script>
  import CartFooter from "./cart-footer.svelte";
  import CartItem from "./cart-item.svelte";
  import { cart } from "$lib/cart-store.svelte.js";
</script>

<div class="flex gap-4 flex-col">
  <header class="border-none">
    <h2 class="text-lg font-semibold">Cart ({cart.itemCount})</h2>
  </header>
  {#if !cart.isEmpty}
    <div class="flex flex-col gap-2">
      {#each cart.lineItems as item, index}
        <CartItem bind:item={cart.lineItems[index]} />
      {/each}
    </div>
  {:else}
    <div
      class="flex items-center justify-center text-sm min-h-14 text-muted-foreground"
    >
      This cart is empty
    </div>
  {/if}
  {#if !cart.isEmpty}
    <CartFooter />
  {/if}
</div>
